import React from "react";

/**
 * Small inline SVG country flag rendered via the `flag-icons` CSS package.
 * Works on every platform including Windows (which does not render
 * regional-indicator emoji flags natively).
 *
 * Usage:  <Flag code="SA" />
 * `code`  ISO-3166 alpha-2 country code (case-insensitive). Falls back to a
 *         plain box when the code is missing/unknown.
 */
export function Flag({ code, className = "", squared = false, title }) {
  const iso = (code || "").toLowerCase();
  if (!iso) {
    return (
      <span
        aria-hidden="true"
        className={`inline-block w-[20px] h-[15px] rounded-[2px] bg-[#e2e8f0] flex-shrink-0 ${className}`}
      />
    );
  }
  const shape = squared ? "fis" : "";
  return (
    <span
      role={title ? "img" : undefined}
      aria-label={title || undefined}
      aria-hidden={title ? undefined : "true"}
      className={`fi fi-${iso} ${shape} inline-block w-[20px] h-[15px] rounded-[2px] bg-cover bg-center flex-shrink-0 shadow-[0_0_0_1px_rgba(15,27,45,0.06)] ${className}`}
    />
  );
}

export default Flag;
